import { createSlice } from '@reduxjs/toolkit';

function getUserFromLocalStorage() {
  try {
    const stored = window.localStorage.getItem('user');
    // Return null if nothing stored or if value is "undefined"
    if (!stored || stored === 'undefined') {
      return null;
    }
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return null;
  }
}

const initialState = {
  user: getUserFromLocalStorage(),
};

const localSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            // You can also update localStorage here if needed
        },
        clearUser: (state) => {
            state.user = null;
            // You can also update localStorage here if needed
        },
    },
});

export const { setUser, clearUser } = localSlice.actions;

export default localSlice.reducer;